import React, { PropTypes } from 'react';
import cx from 'classnames';
import $ from 'jquery';

export default class CheckField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    readOnly: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.onChangeEvt = this.onChangeEvt.bind(this);

    this.state = {
      pristine: true,
    };
  }

  onChangeEvt(evt) {
    const { onChange } = this.props;

    const state = {
      target: {
        name: evt.target.name,
        value: $(evt.target)
          .is(':checked')
          .toString(),
      },
    };
    onChange(state, false);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value && this.state.pristine) {
      this.setState({ pristine: false });
    }
  }

  render() {
    const { name, label, value, required, readOnly } = this.props;
    // const error = this.controlError(value)
    const pristine = this.state.pristine;

    const divClasses = cx('ui slider checkbox', {
      required: required,
      error: !pristine,
    });

    const inputClasses = cx('', {
      disabled: readOnly,
    });

    return (
      <div className={divClasses} onClick={this.onClickEvt}>
        <input
          type="checkbox"
          id={name}
          name={name}
          required={required}
          className={inputClasses}
          onChange={this.onChangeEvt}
          defaultChecked={value && value.value === 'true'}
        />
        <label>{label}</label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/common/bill/CheckField.js